module.exports = __webpack_public_path__ + "media/images/logo-c6d4c63c4bc101e5b0f5fbc88570dfd6.png";